'use strict';exports.__esModule = true;var OPTIONS_STATUS = exports.OPTIONS_STATUS = [
{
  title: 'allStatuses',
  value: 'all' },
{
  title: 'active',
  value: false },
{
  title: 'inactive',
  value: true }];



var OPTIONS_LOCATION = exports.OPTIONS_LOCATION = [
{
  title: 'all_location',
  value: 'all' },
{
  title: 'israel',
  value: false },
{
  title: 'foreign',
  value: true }];



var OPTIONS_PAGINATION = exports.OPTIONS_PAGINATION = [
{
  value: 10,
  label: 10 },
{
  value: 50,
  label: 50 },
{
  value: 100,
  label: 100 }];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyProjects/constants.js
// module id = 2997
// module chunks = 0